<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10"><g clip-path="url(#a)"><path fill="#808FAB" d="M9.583 4.583H5.417V.417A.417.417 0 0 0 5 0a.417.417 0 0 0-.417.417v4.166H.417A.417.417 0 0 0 0 5a.417.417 0 0 0 .417.417h4.166v4.166a.417.417 0 1 0 .834 0V5.417h4.166a.417.417 0 1 0 0-.834Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h10v10H0z"/></clipPath></defs></svg>
</template>

<script>
export default {
  name: 'icon-plus',
}
</script>